export default "__VITE_ASSET__BLgmwxsr__"